import createFusionComponents, { type FusionComponentsOptions } from '@fusion/saas-components-v3'

const componentOptions: FusionComponentsOptions = {
  applicationID: APP_ENV.VITE_APP_APPLICATION_ID,
  clientID: APP_ENV.VITE_APP_CLIENT_ID,
  accountsAPIHost: APP_ENV.VITE_APP_ACCOUNTS_HOST,
  accountsAPIHostV2: APP_ENV.VITE_APP_ACCOUNTS_HOST_V2,
  applicationsAPIHost: APP_ENV.VITE_APP_APPLICATIONS_HOST,
  devicesAPIHost: APP_ENV.VITE_APP_DEVICES_HOST_V3,
  appPublicPath: APP_ENV.VITE_APP_PUBLIC_PATH,
  createAccountLink: APP_ENV.VITE_APP_CREATE_ACCOUNT_URL,
  learnMoreLink: APP_ENV.VITE_APP_LEARN_MORE_URL,
  studiesAPIHostV2: APP_ENV.VITE_APP_STUDIES_HOST_V2,
  studiesAPIHostV3: APP_ENV.VITE_APP_STUDIES_HOST_V3,
  subscriptionsAPIHost: APP_ENV.VITE_APP_SUBS_HOST,
  upgradeURL: APP_ENV.VITE_APP_UPGRADE_URL
}

export const fusionComponents = createFusionComponents(componentOptions)
